import { Styles } from '@monkvision/types';

export const styles: Styles = {
  notCarPart: {
    display: 'none',
  },
  selectable: {
    pointerEvents: 'fill',
    cursor: 'pointer',
  },
  svg: {
    width: '100%',
    height: '100%',
  },
};
